import { Skeleton } from 'primereact/skeleton'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { ICardMostUsedListProps } from '../../models/ICardMostUsedList'
import CardMostUsed from '../card-most-used'
import { Container, Main } from './styles'



export const CardMostUsedList: React.FC<ICardMostUsedListProps> = ({ contents, loading}) => {
    const { t: translation } = useTranslation();
        

    return (
        <>
            <Container>
                <h4>{translation('components.card-most-used-list.Title')}</h4>
                {loading ? (
                <>
                    <Row>
                        <Col md={3}>
                            <Skeleton width="100%" height="150px"/>
                        </Col>
                        <Col md={3}>
                            <Skeleton width="100%" height="150px"/>
                        </Col>
                        <Col md={3}>
                            <Skeleton width="100%" height="150px"/>
                        </Col>
                        <Col md={3}>
                            <Skeleton width="100%" height="150px"/>
                        </Col>
                    </Row>
                </>)
                :(<>
                    <Main>
                        {!!contents.length && contents.map((mostUsed, index) => (
                            <CardMostUsed key={index} onCardClickTest={() => {}}  content={mostUsed} />
                        ))}
                    </Main>
                </>)}
                
            </Container>
        </>
    )
}